<template>
</template>

<script>
	const s = "http://jyw.mixsail.com";
	const token = "";
	const status = "";
	const vclass = "";
	const vip = false;
	export default
	{
		s,//服务器域名
		token,//是否登录
		status,//用户身份
		vclass,//班级
		vip,//是否是vip
	}
</script>

<style>
</style>
